module.exports = "<div id=\"scene\" class=\"scene\">\n</div>"